/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiLocaleRedirectData } from './hei-locale-redirect.data';
import { IHeiLocaleRedirectProps } from './hei-locale-redirect.props.autogenerated';

export interface IHeiLocaleRedirectViewProps extends IHeiLocaleRedirectProps<IHeiLocaleRedirectData> {}

/**
 *
 * HeiLocaleRedirect component
 * @extends {React.PureComponent<IHeiLocaleRedirectProps<IHeiLocaleRedirectData>>}
 */
class HeiLocaleRedirect extends React.PureComponent<IHeiLocaleRedirectProps<IHeiLocaleRedirectData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiLocaleRedirect;
